if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        media: this.querySelector('.product__media'),
        gallerySlider: this.querySelector('.gallery-image-slider'),
        thumbSlider: this.querySelector('.thumbnail-slider ')
      }

      // Add resize observer to update container height
      const resizeObserver = new ResizeObserver(entries => this.update());
      resizeObserver.observe(this); 
    }


    update() {
      if(this.elements.gallerySlider && this.elements.media){
        this.elements.gallerySlider.style.height = `${this.elements.media.offsetHeight}px`;
      }
      if(this.elements.thumbSlider && this.elements.media){
        this.elements.thumbSlider.style.height = `${this.elements.media.offsetHeight}px`;
      }
    }
  });
}
